module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"locale":{"english":"Inglês","portuguese":"Português","spanish":"Espanhol","mandarin":"Mandarim"}},"en":{"locale":{"english":"English","portuguese":"Portuguese","spanish":"Spanish","mandarin":"Mandarin"}}}')
  delete Component.options._Ctor
}
